<lms-breadcrumb
  *ngIf="group; else noGroupName"
  [crumbs]="[
    { route: '/groups', label: 'groups.label', icon: 'glicon-class' },
    { label: group.name, route: '.' }
  ]"
>
</lms-breadcrumb>
<ng-template #noGroupName>
  <lms-breadcrumb
    [crumbs]="[
      { route: '/groups', label: 'groups.label', icon: 'glicon-class' },
      { label: 'groups.createMarsGroup', route: '.' }
    ]"
  >
  </lms-breadcrumb>
  <lms-mars1-group-data [group]="group" (save)="onGroupDataSaved($event)">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="onDelete()" form-actions-before>
    </gl-button>
  </lms-mars1-group-data>
</ng-template>

<mat-tab-group
  class="tab-group"
  #tabGroup
  *ngIf="group"
  animationDuration="0ms"
  disableRipple="true"
  (selectedTabChange)="setTab($event)"
>
  <mat-tab label="dashboard">
    <ng-template mat-tab-label>{{ 'groups.tabs.dashboard' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-group-dashboard></lms-group-dashboard>
    </ng-template>
  </mat-tab>
  <mat-tab *lmsProfileGuard="'groups.group.data'" label="data">
    <ng-template mat-tab-label>{{ 'groups.tabs.data' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars1-group-data [group]="group" (save)="onGroupDataSaved($event)"></lms-mars1-group-data>
    </ng-template>
  </mat-tab>
  <mat-tab *lmsProfileGuard="'groups.group.notifications'" label="notifications">
    <ng-template mat-tab-label>{{ 'groups.tabs.notifications' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-group-notifications [group]="group" [client]="client"></lms-group-notifications>
    </ng-template>
  </mat-tab>
  <mat-tab *lmsProfileGuard="'groups.group.enrollment'" label="enrollment">
    <ng-template mat-tab-label>{{ 'groups.tabs.enrollment' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-group-enrollment
        [group]="group"
        [course]="course"
        [game]="game"
        (updateEnrollment)="onUpdateEnrollment($event)"
      ></lms-group-enrollment>
    </ng-template>
  </mat-tab>
  <mat-tab *lmsProfileGuard="'groups.group.config'" label="config">
    <ng-template mat-tab-label>{{ 'groups.tabs.config' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars1-group-config [group]="group" (save)="onUpdate($event)"></lms-mars1-group-config>
    </ng-template>
  </mat-tab>
  <mat-tab *lmsProfileGuard="'groups.group.activity'" label="activity">
    <ng-template mat-tab-label>{{
      (group && group.hasBonus ? 'nouns.bonusActivityReport' : 'nouns.activityReport') | translate
    }}</ng-template>
    <ng-template matTabContent>
      <lms-group-activity [group]="group" [course]="course"></lms-group-activity>
    </ng-template>
  </mat-tab>
  <mat-tab *lmsProfileGuard="'groups.group.surveys'" label="surveys">
    <ng-template mat-tab-label>{{ 'groups.tabs.surveys' | translate }}</ng-template>
    <ng-template matTabContent>
      <gl-surveys-report
        [filters]="{ clientId: group.clientId, groupId: group.id }"
        [config]="{ reportFilters: false, columnChooser: false, download: false, filter: false }"
      >
      </gl-surveys-report>
    </ng-template>
  </mat-tab>
  <mat-tab label="tutorization" *lmsProfileGuard="'groups.group.tutorization'" [disabled]="!group">
    <ng-template mat-tab-label>{{ 'groups.tabs.tutorization' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars-group-tutorization [group]="group" [game]="game"></lms-mars-group-tutorization>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<div *ngIf="group" class="gl-context-menu__position">
  <lms-button-actions>
    <div class="gl-context-menu__options">
      <div *ngIf="group.hasBonus">
        <span
          *lmsProfileGuard="'groups.supervise'"
          class="gl-context-menu__options--item"
          (click)="supervisorUrlOpen()"
          >{{ 'actions.supervise' | translate }}</span
        >
        <span
          *lmsProfileGuard="'groups.reset'"
          class="gl-context-menu__options--item"
          (click)="resetGameSupervisor()"
          >{{ 'actions.resetGame' | translate }}</span
        >
        <span
          *lmsProfileGuard="'groups.create-bonus'"
          class="gl-context-menu__options--item"
          (click)="resendBlueMail()"
          >{{ 'actions.resendBlueMail' | translate }}</span
        >
      </div>
      <span *lmsProfileGuard="'groups.delete'" class="gl-context-menu__options--item alert" (click)="deleteGroup()">{{
        'actions.delete' | translate
      }}</span>
    </div>
  </lms-button-actions>
</div>
